import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  extractAndStoreBusinessCentralHint,
  hasStoredBusinessCentralHint,
  isBusinessCentralConnectPath,
} from "./businessCentralConnectUtils";

export const useBusinessCentralConnect = () => {
  const [
    shouldRenderBusinessCentralConnect,
    setShouldRenderBusinessCentralConnect,
  ] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hasHint = hasStoredBusinessCentralHint();
    if (isBusinessCentralConnectPath() || hasHint) {
      if (!hasHint) {
        extractAndStoreBusinessCentralHint();
      }

      // We can arrive on the Business Central connect path in two scenarios:
      // 1. A newly signed-up/logged-in user is resuming a connect attempt started before
      //    authentication. In this case a Tally `token` is already in localStorage.
      // 2. A visitor is arriving fresh from the bc-extension Assisted Setup deep link and is
      //    not authenticated yet. We should not render the connect UI - the caller bounces
      //    them into sign-up instead.
      const hasToken = localStorage.getItem("token");
      if (hasToken) {
        setShouldRenderBusinessCentralConnect(true);
        return;
      }
      setShouldRenderBusinessCentralConnect(false);
    } else {
      setShouldRenderBusinessCentralConnect(false);
    }
  }, [location.pathname]);

  return {
    shouldRenderBusinessCentralConnect,
    isBusinessCentralConnectPath: isBusinessCentralConnectPath(),
  };
};
